import { gql } from '@urql/core';
import React, { useMemo } from 'react';
import { GpaCardFragment } from '../../../generated/spin-graphql';

type Props = {
    player: GpaCardFragment;
};

gql`
    fragment GPACard on espin_player_profile {
        gpa
    }
`;

export const GPACard: React.FC<Props> = ({ player }) => {
    return (
        <div className="profile-card dark-theme">
            <div className="title-container">
                <h2 className="title">GPA</h2>
            </div>
            <p className="value gpa">{(player.gpa as number).toFixed(1)}</p>
        </div>
    );
};
